import type { AvatarKind } from "@prototypes/avatar/avatarUrl";
import { getDownloadURL, type StorageReference } from "firebase/storage";
import { agentAvatarThumbnailRef, memberAvatarThumbnailRef } from "../FirebaseBackend";

const downloadUrls = new Map<string, Promise<string>>();

const thumbnailRef = {
    agent: agentAvatarThumbnailRef,
    member: memberAvatarThumbnailRef,
};

export async function resolveAvatarUrl(kind: AvatarKind, id: string) {
    try {
        return await getCachedDownloadURL(thumbnailRef[kind](id));
    } catch {
        return null;
    }
}

/** Download URL of a storage object, resolved once per path for the session. */
export function getCachedDownloadURL(storageRef: StorageReference) {
    const cached = downloadUrls.get(storageRef.fullPath);
    if (cached) return cached;

    const pending = getDownloadURL(storageRef);
    downloadUrls.set(storageRef.fullPath, pending);
    return pending;
}
